const gtmSubmitRegistration = (cinestar_club) => {
    dataLayer.push({
        event: 'registration',
        step: 'submit',
        cinestar_club: cinestar_club ? 'ano' : 'ne',
        _clear: true,
    })
}

export default gtmSubmitRegistration
